import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ThemeModule } from '../../@theme/theme.module';
import {
  NbCardModule,
  NbButtonModule,
  NbInputModule,
  NbIconModule,
  NbAlertModule,
  NbLayoutModule,
  NbToastrModule,
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { SharedModule } from '../shared/shared.module';
import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [{ path: '', component: LoginComponent, pathMatch: 'full' }],
  },
];

@NgModule({
  imports: [
    
    NbLayoutModule,
    NbEvaIconsModule,
    NbIconModule,
    RouterModule.forChild(routes),
    NbToastrModule.forRoot(),
    FormsModule,
    TranslateModule,
    ThemeModule,
    NbCardModule,
    NbButtonModule,
    NbInputModule,
    NbAlertModule,
    SharedModule,
  ],
  declarations: [AuthComponent, LoginComponent],
  providers: [],
  entryComponents: [],
})
export class AuthModule {}
